import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const CREATE_EMAIL_THREAD = createAsyncActionTypes('CREATE_EMAIL_THREAD');